;(function () {
	const header = () => {
		const headerSection = document.querySelector('.shopify-section-header')
		const search = document.querySelector('.header__search')

		let hideMenuTimeout

		if (headerSection) {
			headerSection.addEventListener('keydown', (e) => {
				if (e.code === 'Escape' && search && search.isOpen) {
					search.close()
				}
			})
		}

		// Announcement bar height observer
		const annBar = document.querySelector('.section-announcement')
		const annBarObserver = new IntersectionObserver((entries) => {
			const [entry] = entries
			if (entry.isIntersecting) {
				document.documentElement.style.setProperty('--ann-height', `${entry.intersectionRect.height}px`)
			} else {
				document.documentElement.style.setProperty('--ann-height', `0px`)
			}
		})
		if (annBar) annBarObserver.observe(annBar)

		// Correct selectors
		const annBarNav = document.querySelector('.header__inline-container .header__inline-menu')
		const mainNav = document.querySelector('nav.header__inline-menu')

		// Close all menus in a given nav container
		const closeNavMenus = (navContainer, megaMenuSelector) => {
			if (!navContainer) return
			navContainer.querySelectorAll(megaMenuSelector).forEach((m) => {
				m.style.opacity = 0
				m.style.display = 'none'
				m.style.right = 'auto'
			})
			navContainer.querySelectorAll('.list-menu-item').forEach((el) => {
				el.classList.remove('list-menu--megamenu-visible')
			})
		}

		// Close everything
		const closeAllMenus = () => {
			closeNavMenus(mainNav, '.mega-menu')
			// Ann bar
			if (annBarNav) {
				annBarNav.querySelectorAll('.mega-menu').forEach((m) => {
					m.style.opacity = 0
					m.style.display = 'none'
				})
				annBarNav.querySelectorAll('.list-menu-item').forEach((el) => {
					el.classList.remove('list-menu--megamenu-visible')
				})
			}
		}

		// ---- ANN BAR MENU ----
		if (annBarNav) {
			const annLinks = annBarNav.querySelectorAll('.list-menu-item')

			annLinks.forEach((link) => {
				const popup = link.querySelector('.mega-menu-popup')
				const innerMegaMenu = popup ? popup.querySelector('.mega-menu') : null

				const openAnnMenu = () => {
					if (!link.classList.contains('list-menu--megamenu')) return
					link.classList.add('list-menu--megamenu-visible')
					if (innerMegaMenu) {
						innerMegaMenu.style.opacity = 0
						innerMegaMenu.style.display = 'grid'
						setTimeout(() => { innerMegaMenu.style.opacity = 1 }, 100)
					}
					popup && popup.querySelectorAll('a[tabindex="-1"]').forEach((a) => a.removeAttribute('tabindex'))
				}

				const closeAnnMenu = () => {
					link.classList.remove('list-menu--megamenu-visible')
					if (innerMegaMenu) {
						innerMegaMenu.style.opacity = 0
						innerMegaMenu.style.display = 'none'
					}
				}

				link.addEventListener('mouseenter', openAnnMenu)
				link.addEventListener('mouseleave', closeAnnMenu)

				const trigger = link.querySelector('.header__menu-item')
				if (trigger) {
					trigger.addEventListener('focus', openAnnMenu)
					trigger.addEventListener('focusin', openAnnMenu)
				}
			})

			annBarNav.addEventListener('focusout', () => {
				setTimeout(() => {
					if (!annBarNav.contains(document.activeElement)) {
						annLinks.forEach((link) => {
							link.classList.remove('list-menu--megamenu-visible')
							const innerMegaMenu = link.querySelector('.mega-menu-popup .mega-menu')
							if (innerMegaMenu) {
								innerMegaMenu.style.opacity = 0
								innerMegaMenu.style.display = 'none'
							}
						})
					}
				}, 150)
			})
		}

		// ---- MAIN NAV MENU ----
		if (mainNav) {
			const mainLinks = mainNav.querySelectorAll('.list-menu-item')
			const megaMenus = mainNav.querySelectorAll('.mega-menu')

			mainLinks.forEach((link) => {
				const megaMenu = link.querySelector('.mega-menu')
				const hasMegaMenu = link.classList.contains('list-menu--megamenu')

				const openMenu = () => {
					link.classList.add('list-menu--megamenu-visible')
					if (!megaMenu) return

					megaMenu.style.opacity = 0
					megaMenu.style.display = 'grid'
					setTimeout(() => { megaMenu.style.opacity = 1 }, 100)

					// Position calculation
					const headerMain = headerSection ? headerSection.querySelector('.header') : null
					if (headerMain) {
						const calcPosition = () => {
							megaMenu.style.right = 'auto'
							const megaMenuTabs = megaMenu.querySelector('.mega-menu__tabs')
							if (megaMenuTabs && megaMenuTabs.scrollWidth > megaMenu.offsetWidth) {
								megaMenu.style.maxWidth = `${megaMenuTabs.scrollWidth}px`
								megaMenu.style.width = `${megaMenuTabs.scrollWidth}px`
							}
							const megaMenuRight = megaMenu.getBoundingClientRect().right
							const headerRight = headerMain.getBoundingClientRect().right
							if (megaMenuRight > headerRight) {
								megaMenu.style.right = '2rem'
							}
						}
						calcPosition()

						let headerMainWidth = headerMain.offsetWidth
						const resizeObserver = new ResizeObserver((entries) => {
							for (const entry of entries) {
								const newWidth = entry.contentRect.width
								if (newWidth !== headerMainWidth) {
									headerMainWidth = newWidth
									calcPosition()
								}
							}
						})
						resizeObserver.observe(headerMain)
					}

					// Close other menus in same nav
					mainLinks.forEach((el) => {
						if (el !== link) {
							el.classList.remove('list-menu--megamenu-visible')
							const other = el.querySelector('.mega-menu')
							if (other) {
								other.style.opacity = 0
								other.style.display = 'none'
							}
						}
					})
				}

				const closeMenu = () => {
					link.classList.remove('list-menu--megamenu-visible')
					if (!megaMenu) return
					megaMenu.style.opacity = 0
					megaMenu.style.display = 'none'
				}

				// Mouse enter
				link.addEventListener('mouseenter', () => {
					clearTimeout(hideMenuTimeout)
					if (hasMegaMenu) {
						openMenu()
					} else {
						// No submenu - close all open menus
						mainLinks.forEach((el) => {
							el.classList.remove('list-menu--megamenu-visible')
							const other = el.querySelector('.mega-menu')
							if (other) {
								other.style.opacity = 0
								other.style.display = 'none'
							}
						})
					}
				})

				// Mouse leave
				link.addEventListener('mouseleave', () => {
					if (hasMegaMenu) {
						hideMenuTimeout = setTimeout(() => closeMenu(), 100)
					}
				})

				// Keyboard: focus on <a> tag
				const trigger = link.querySelector('.header__menu-item')
				if (trigger) {
					trigger.addEventListener('focus', () => {
						if (hasMegaMenu) {
							openMenu()
						} else {
							// No submenu - close all open menus in main nav
							mainLinks.forEach((el) => {
								el.classList.remove('list-menu--megamenu-visible')
								const other = el.querySelector('.mega-menu')
								if (other) {
									other.style.opacity = 0
									other.style.display = 'none'
								}
							})
						}
					})
				}
			})

			// Mouse leave entire nav
			mainNav.addEventListener('mouseleave', () => {
				clearTimeout(hideMenuTimeout)
				setTimeout(() => {
					megaMenus.forEach((m) => {
						m.style.right = 'auto'
						m.style.display = 'none'
						m.style.opacity = 0
					})
					mainLinks.forEach((link) => link.classList.remove('list-menu--megamenu-visible'))
				}, 100)
			})

			// Focus leaves main nav
			mainNav.addEventListener('focusout', () => {
				setTimeout(() => {
					if (!mainNav.contains(document.activeElement)) {
						closeNavMenus(mainNav, '.mega-menu')
					}
				}, 150)
			})
		}

		// Close when focus goes to logo or header icons
		const headerHeadingLink = document.querySelector('.header__heading-link')
		const headerIcons = document.querySelector('.header__icons')

		document.addEventListener('focusin', (e) => {
			const activeEl = e.target
			const isOnLogo = activeEl === headerHeadingLink
			const isOnIcons = headerIcons && headerIcons.contains(activeEl)
			if (isOnLogo || isOnIcons) {
				closeAllMenus()
			}
		})

		// Mega menu tabs
		const megaMenuTabs = () => {
			$('.mega-menu__tab-wrapper').children().find('.mega-menu__tab-wrapper').first().addClass('mega-menu__tab-wrapper--active')
			$('.mega-menu__tab-wrapper').mouseenter(function () {
				$('.mega-menu__tab-wrapper').removeClass('mega-menu__tab-wrapper--active')
				$(this).addClass('mega-menu__tab-wrapper--active')
			})
			$('.mega-menu__tab-wrapper').focus(function () {
				$('.mega-menu__tab-wrapper').removeClass('mega-menu__tab-wrapper--active')
				$(this).addClass('mega-menu__tab-wrapper--active')
			})
			$('.mega-menu__tab-wrapper').focusin(function () {
				$('.mega-menu__tab-wrapper').removeClass('mega-menu__tab-wrapper--active')
				$(this).addClass('mega-menu__tab-wrapper--active')
			})
		}
		megaMenuTabs()

		const main = document.querySelector('main')
		if (
			main &&
			main.querySelectorAll('.shopify-section')[0] &&
			main.querySelectorAll('.shopify-section')[0].classList.contains('section--has-overlay')
		) {}

		const menuCloseBtn = document.querySelector('.header__modal-close-button')
		const mobileMenuDrawer = document.querySelector('header-drawer')
		if (menuCloseBtn && mobileMenuDrawer) {
			menuCloseBtn.addEventListener('click', (e) => {
				mobileMenuDrawer.closeMenuDrawer(e)
			})
		}
	}

	document.addEventListener('shopify:section:load', header)
	document.addEventListener('shopify:section:unload', header)
	document.addEventListener('shopify:section:reorder', header)

	header()
})()